"use client"
import { createContext, useContext } from "react"

const state = {
    time: 7,
    sort: "stars:desc",
    withSold: true,
    pointsMin: 20,
    pointsMax: 1600,
    useMonth: [] as string[],
    resorts: [] as number[]
}
const contextValue = {
    ...state,
    setState: (s: Partial<Omit<typeof state, "setState">>) => void 0
}
const Context = createContext(contextValue)

export type ContextType = typeof state

export const Provider = Context.Provider

export function useDealsContext() {
    return useContext(Context)
}
